import { Flex, Text } from '@stars-ecom/shared-atoms-ui'
import React, { memo } from 'react'
import { OfferUtils, priceFormat, getMultipaymentPrice } from '../../utils'

const FinalPrice = (props) => {
  const {
    product,
    productVariant,
    type = 'STANDARD',
    multipaymentData = [],
  } = props

  const {
    price = 0,
    currency = '€'
  } = productVariant
    ? OfferUtils.getCurrentVariantOffer(productVariant, type, process.env.GATSBY_API_CHANNEL_ID)
    : OfferUtils.getCurrentProductOffer(product, type, process.env.GATSBY_API_CHANNEL_ID)

  const multipaymentEligibility = multipaymentData[0].min <= price ? true : false    
  const getMultipayment = getMultipaymentPrice(price, multipaymentData)

  return (
    <Flex>
      {multipaymentEligibility ? (
        <Text style={{ color: "#000", fontFamily: 'PT Sans Narrow,PT Sans,Arial,sans-serif', fontSize:"25px", fontWeight:'700',  lineHeight: '30px'  }}>
          <Text as="span" style={{ fontSize: "33px" }}>
            {priceFormat(getMultipayment.installment, currency)}
            </Text> x<Text as="span">{getMultipayment.count}</Text>
          </Text>) :
        ( <Text
          as="span"
          alignSelf={{ base: 'start', md: 'end' }}
          fontSize="28px"
          fontWeight="700"
          color="#000"
          fontFamily="PT Sans Narrow,PT Sans,Arial,sans-serif">{`${priceFormat(price , currency)}`}</Text>
        )
      }
    </Flex>
  )
}

export default memo(FinalPrice)